import React from 'react';
import { ImageBackground } from 'react-native';
import { Text, Heading, Button, Modal, Pressable, Box } from 'native-base';

export const FoodGuideInfo = ({
  isFoodGuideModalVis,
  setIsFoodGuideModalVis,
}) => {
  const closeBttn = './../../assets/images/close-icon.png';
  const styles = {
    icon: {
      width: 32,
      height: 32,
    },
    closeContainer: {
      position: 'absolute',
      top: 15,
      right: 15,
      height: 32,
      width: 32,
    },
  };

  return (
    <Modal
      _backdrop={{
        bg: 'black',
        opacity: '.75',
      }}
      isOpen={isFoodGuideModalVis}
      size={'lg'}
      zIndex={10}
    >
      <Modal.Content>
        <Modal.Header>
          <Heading fontSize={24} fontFamily="heading">
            Your Food Guide
          </Heading>
          <Box style={styles.closeContainer}>
            <Pressable onPress={() => setIsFoodGuideModalVis(false)}>
              <ImageBackground
                resizeMode="contain"
                source={closeBttn}
                style={styles.icon}
              />
            </Pressable>
          </Box>
        </Modal.Header>
        <Modal.Body>
          <Text fontSize={'lg'}>
            Use this guide to help you choose delicious alternatives for your
            eliminated foods. These suggested swaps help ensure that you don't
            miss out on any nutrients (or flavors!), even when avoiding certain
            foods. If you have any questions, don't hesitate to ask your coach.
          </Text>
          <Button
            mt={6}
            onPress={() => {
              setIsFoodGuideModalVis(false);
            }}
          >
            Got It!
          </Button>
        </Modal.Body>
      </Modal.Content>
    </Modal>
  );
};

export default FoodGuideInfo;
